import {Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'phase-cohorts-details',
    templateUrl: './phase-cohorts-details.component.html',
    styleUrls: ['./phase-cohorts-details.component.scss']
})

export class PhaseCohortsDetailsComponent{
    @Input()
    cohorts: string[];

    @Input()
    devices?: number;

    @Input()
    online?: number;
}